import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase-config';
import {
  AI_PIPELINE_LEGACY,
  AI_PIPELINE_SCHEMA_V1,
  AI_PIPELINE_SCHEMA_V2,
  normalizeAiPipelineMode,
} from '../constants/aiPipelineModes';

const SETTINGS_DOC = 'aiPipeline';

/**
 * Active AI pipeline for SEF diagnostic, evidence distill/refinery, and report draft.
 * Stored at settings/aiPipeline — ringfence switch; default legacy.
 */
export async function getAiPipelineMode() {
  try {
    const snap = await getDoc(doc(db, 'settings', SETTINGS_DOC));
    if (!snap.exists()) return AI_PIPELINE_LEGACY;
    return normalizeAiPipelineMode(snap.data()?.mode);
  } catch (err) {
    console.error('getAiPipelineMode failed; defaulting to legacy', err);
    return AI_PIPELINE_LEGACY;
  }
}

export async function getAiPipelineSettings() {
  const mode = await getAiPipelineMode();
  try {
    const snap = await getDoc(doc(db, 'settings', SETTINGS_DOC));
    const data = snap.exists() ? snap.data() : {};
    return {
      mode,
      updatedAt: data.updatedAt || null,
      updatedBy: data.updatedBy || null,
      note: data.note || '',
    };
  } catch (err) {
    return { mode, updatedAt: null, updatedBy: null, note: '' };
  }
}

/**
 * @param {'legacy'|'schema_v1'|'schema_v2'} mode
 * @param {{ uid?: string, email?: string }} actor
 */
export async function setAiPipelineMode(mode, actor = {}) {
  const next = normalizeAiPipelineMode(mode);
  if (
    next !== AI_PIPELINE_LEGACY &&
    next !== AI_PIPELINE_SCHEMA_V1 &&
    next !== AI_PIPELINE_SCHEMA_V2
  ) {
    throw new Error('Invalid AI pipeline mode');
  }
  const note =
    next === AI_PIPELINE_SCHEMA_V2
      ? 'Schema v2 pipeline (per-file + schema). Legacy and v1 untouched.'
      : next === AI_PIPELINE_SCHEMA_V1
        ? 'Schema v1 verification pipeline (ringfenced). Legacy code untouched.'
        : 'Legacy production pipeline.';
  await setDoc(
    doc(db, 'settings', SETTINGS_DOC),
    {
      mode: next,
      updatedAt: serverTimestamp(),
      updatedBy: actor.uid || actor.email || 'unknown',
      note,
    },
    { merge: true }
  );
  return next;
}
